(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_rr_media_magazine_slider"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (root) => {
      if (root.dataset.rrMediaInit || typeof Swiper === 'undefined') return;
      root.dataset.rrMediaInit = '1';
      new Swiper(root.querySelector('.rr-media-magazine-slider__swiper'), {
        slideClass: 'shopify-block',
        loop: root.dataset.loop === 'true',
        slidesPerView: Number(root.dataset.perSp),
        spaceBetween: Number(root.dataset.gapSp),
        slidesPerGroup: 1,
        speed: root.dataset.noAnimation === 'true' ? 0 : Number(root.dataset.speed),
        ...(root.dataset.autoplay === 'true'
          ? { autoplay: { delay: Number(root.dataset.delaySp), disableOnInteraction: false } }
          : {}),
        breakpoints: {
          768: {
            slidesPerView: Number(root.dataset.per),
            spaceBetween: Number(root.dataset.gap),
            ...(root.dataset.autoplay === 'true'
              ? { autoplay: { delay: Number(root.dataset.delay), disableOnInteraction: false } }
              : {})
          }
        }
      });
    };

    const initAll = () => {
      const roots = [...document.querySelectorAll('.rr-media-magazine-slider')];
      if (!roots.length) return;
      if (typeof Swiper !== 'undefined') {
        roots.forEach(init);
        return;
      }
      const existing = document.querySelector('script[data-rr-media-swiper]');
      if (existing) {
        existing.addEventListener('load', () => roots.forEach(init), { once: true });
        return;
      }
      const script = document.createElement('script');
      script.src = roots[0].dataset.swiperUrl;
      script.dataset.rrMediaSwiper = 'true';
      script.addEventListener('load', () => roots.forEach(init), { once: true });
      document.head.appendChild(script);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_rr_product_grid"] && !Shopify.designMode) return;
  try {
    (() => {
    const initProductCarousel = (carousel) => {
      if (carousel.dataset.rrProductCarouselInit) return;
      carousel.dataset.rrProductCarouselInit = '1';

      const track = carousel.querySelector('.rr-product-grid--carousel');
      const dotsBox = carousel.querySelector('.rr-product-grid__dots');
      const previous = carousel.querySelector('.rr-product-grid__arrow--prev');
      const next = carousel.querySelector('.rr-product-grid__arrow--next');
      if (!track || !previous || !next) return;

      const config = {
        autoplay: carousel.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
        interval: (parseFloat(carousel.dataset.interval) || 3) * 1000,
        speed: (parseFloat(carousel.dataset.speed) || 0.6) * 1000,
        loop: carousel.dataset.loop === 'true',
        pauseHover: carousel.dataset.pauseHover === 'true'
      };
      const slides = () => [...track.children];
      const step = () => {
        const items = slides();
        if (items.length < 2) return track.clientWidth;
        return items[1].offsetLeft - items[0].offsetLeft;
      };
      const maxIndex = () => {
        const unit = step();
        return unit > 0 ? Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / unit)) : 0;
      };
      const current = () => {
        const unit = step();
        return unit > 0 ? Math.min(maxIndex(), Math.round(track.scrollLeft / unit)) : 0;
      };

      let animationId = null;
      const goTo = (index) => {
        if (animationId) cancelAnimationFrame(animationId);
        const from = track.scrollLeft;
        const to = Math.min(maxIndex(), Math.max(0, index)) * step();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          track.scrollLeft = to;
          updateDots();
          return;
        }
        const startedAt = performance.now();
        const ease = (progress) => progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;
        const frame = (now) => {
          const progress = Math.min(1, (now - startedAt) / config.speed);
          track.scrollLeft = from + (to - from) * ease(progress);
          if (progress < 1) {
            animationId = requestAnimationFrame(frame);
          } else {
            animationId = null;
          }
        };
        animationId = requestAnimationFrame(frame);
      };

      const updateDots = () => {
        if (!dotsBox) return;
        [...dotsBox.children].forEach((dot, index) => {
          const isActive = index === current();
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };
      const buildDots = () => {
        if (!dotsBox) return;
        dotsBox.innerHTML = '';
        for (let index = 0; index <= maxIndex(); index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'rr-product-grid__dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', `${carousel.dataset.dotLabel} ${index + 1}`);
          dot.addEventListener('click', () => { goTo(index); scheduleAutoplay(); });
          dotsBox.append(dot);
        }
        const navigable = maxIndex() > 0;
        previous.hidden = !navigable;
        next.hidden = !navigable;
        dotsBox.hidden = !navigable;
        updateDots();
      };

      let timer = null;
      let visible = true;
      let hovering = false;
      const stopAutoplay = () => {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      };
      const scheduleAutoplay = () => {
        stopAutoplay();
        if (!config.autoplay) return;
        timer = setTimeout(() => {
          if (visible && !hovering && !document.hidden) {
            const nextIndex = current() + 1;
            if (nextIndex > maxIndex()) {
              if (config.loop) goTo(0);
            } else {
              goTo(nextIndex);
            }
          }
          scheduleAutoplay();
        }, config.interval);
      };

      previous.addEventListener('click', () => { goTo(current() - 1); scheduleAutoplay(); });
      next.addEventListener('click', () => { goTo(current() + 1); scheduleAutoplay(); });
      let scrollFrame = null;
      track.addEventListener('scroll', () => {
        if (scrollFrame) return;
        scrollFrame = requestAnimationFrame(() => { scrollFrame = null; updateDots(); });
      });
      track.addEventListener('pointerdown', () => {
        if (animationId) cancelAnimationFrame(animationId);
        scheduleAutoplay();
      });
      if (config.pauseHover) {
        carousel.addEventListener('mouseenter', () => { hovering = true; });
        carousel.addEventListener('mouseleave', () => { hovering = false; });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; }).observe(carousel);
      }
      window.addEventListener('resize', buildDots);
      buildDots();
      scheduleAutoplay();
    };

    const initAll = () => document.querySelectorAll('.rr-product-grid-carousel').forEach(initProductCarousel);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_rr_slider"] && !Shopify.designMode) return;
  try {
    (() => {
    const initSlider = (slider) => {
      if (slider.dataset.rrInit) return;
      slider.dataset.rrInit = '1';
      const track = slider.querySelector('.rr-slider__track');
      const dotsBox = slider.querySelector('.rr-slider__dots');
      const speedValue = parseFloat(slider.dataset.speed);
      const cfg = {
        autoplay: slider.dataset.autoplay === 'true',
        speed: (Number.isFinite(speedValue) ? Math.max(0, speedValue) : 0.6) * 1000,
        loop: slider.dataset.loop === 'true',
        pauseHover: slider.dataset.pauseHover === 'true',
        autoHide: slider.dataset.autoHide === 'true',
        thumbs: slider.dataset.thumbs === 'true'
      };
      // 全部が1画面に収まっていて動かす余地がない時は矢印を隠す（設定がオンの時だけ）
      const lockCheck = () => {
        slider.classList.toggle('is-locked', cfg.autoHide && track.scrollWidth <= track.clientWidth + 1);
      };
      const slides = () => [...track.children];
      // そのスライドが実際に表示している写真を取り出す（背景画像＝袋部品、img＝写真部品の両対応）
      const thumbImage = (slide) => {
        if (!slide) return '';
        const cands = [slide, ...slide.querySelectorAll('*')];
        for (const el of cands) {
          const bg = getComputedStyle(el).backgroundImage;
          if (bg && bg !== 'none' && bg.includes('url(')) return bg;
        }
        const im = slide.querySelector('img');
        return im && im.currentSrc ? 'url("' + im.currentSrc + '")' : '';
      };
      const step = () => {
        const s = slides();
        if (s.length < 2) return track.clientWidth;
        return s[1].offsetLeft - s[0].offsetLeft;
      };
      const maxIndex = () => Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / step()));
      const current = () => Math.min(maxIndex(), Math.round(track.scrollLeft / step()));

      let animId = null;
      const goTo = (i) => {
        if (animId) cancelAnimationFrame(animId);
        const from = track.scrollLeft;
        const to = Math.min(maxIndex(), Math.max(0, i)) * step();
        if (cfg.speed === 0) {
          track.scrollLeft = to;
          return;
        }
        const start = performance.now();
        const ease = (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        const frame = (now) => {
          const p = Math.min(1, (now - start) / cfg.speed);
          track.scrollLeft = from + (to - from) * ease(p);
          if (p < 1) {
            animId = requestAnimationFrame(frame);
          } else {
            animId = null;
          }
        };
        animId = requestAnimationFrame(frame);
      };

      let timer = null;
      let visible = true;
      let hovering = false;
      const intervalMs = () => {
        const isSp = window.matchMedia('(max-width: 749px)').matches;
        const seconds = parseFloat(isSp ? slider.dataset.intervalSp : slider.dataset.interval);
        return (Number.isFinite(seconds) ? seconds : 3) * 1000;
      };
      const stopAuto = () => { if (timer) { clearTimeout(timer); timer = null; } };
      const scheduleAuto = () => {
        stopAuto();
        if (!cfg.autoplay) return;
        timer = setTimeout(() => {
          if (visible && !hovering && !document.hidden) {
            const next = current() + 1;
            if (next > maxIndex()) {
              if (cfg.loop) goTo(0);
            } else {
              goTo(next);
            }
          }
          scheduleAuto();
        }, intervalMs());
      };

      const buildDots = () => {
        lockCheck();
        if (!dotsBox) return;
        dotsBox.innerHTML = '';
        const count = maxIndex() + 1;
        const list = slides();
        for (let i = 0; i < count; i++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = cfg.thumbs ? 'rr-slider__thumb' : 'rr-slider__dot';
          b.setAttribute('aria-label', (i + 1) + '枚目へ');
          if (cfg.thumbs) {
            const img = thumbImage(list[i]);
            if (img) b.style.backgroundImage = img;
          }
          b.addEventListener('click', () => { goTo(i); scheduleAuto(); });
          dotsBox.append(b);
        }
        update();
      };

      const update = () => {
        if (!dotsBox) return;
        [...dotsBox.children].forEach((d, i) => d.classList.toggle('is-active', i === current()));
      };

      slider.querySelector('.rr-slider__arrow--prev').addEventListener('click', () => { goTo(current() - 1); scheduleAuto(); });
      slider.querySelector('.rr-slider__arrow--next').addEventListener('click', () => { goTo(current() + 1); scheduleAuto(); });

      let raf = null;
      track.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => { raf = null; update(); });
      });
      track.addEventListener('pointerdown', () => { if (animId) cancelAnimationFrame(animId); scheduleAuto(); });
      if (cfg.pauseHover) {
        slider.addEventListener('mouseenter', () => { hovering = true; });
        slider.addEventListener('mouseleave', () => { hovering = false; });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; }).observe(slider);
      }
      window.addEventListener('resize', buildDots);
      buildDots();
      scheduleAuto();
    };

    const initAll = () => document.querySelectorAll('.rr-slider').forEach(initSlider);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', (e) => {
      const track = e.target.closest && e.target.closest('.rr-slider__track');
      if (track && e.target.parentElement === track) {
        e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
